import axios from "axios"
import { Event } from "../types"

export const updateEvent = async (eventId: string, event: Partial<Event>) => {
  try {
    // Convert is_featured / featured_priority for DB
    event.is_featured = event.is_featured ? +event.is_featured : 0
    event.featured_priority = event.featured_priority ? +event.featured_priority : null
    const res = await axios.patch(`/events/${eventId}`, { ...event })
    return res.data
  } catch (err) {
    console.log("updateEvent err", err)
  }

  return null
}
